import { api } from "@/lib/api";

// Poll an async import job until it is done/failed. Returns the full job document.
// Backend endpoints return { job_id } immediately and process in the background,
// which avoids Cloudflare 524 timeouts on slow object-storage writes.
export async function pollImportJob(jobId, { interval = 2000, timeoutMs = 15 * 60 * 1000, onTick } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    const { data } = await api.get(`/admin/solutions/import_jobs/${jobId}`);
    if (onTick) onTick(data);
    if (data.status === "done" || data.status === "failed") return data;
    await new Promise((r) => setTimeout(r, interval));
  }
  throw new Error("Délai dépassé — l'import continue en arrière-plan, vérifiez la liste des solutions dans un instant.");
}
